import React from 'react';
import './WhereWeWork.css';
import afgMap from '../images/new_group_project1.jpg';

const OnGoingProject: React.FC = () => {
  return (
    <div className="where-we-work-page">


      <section className="clean-map-section">
        <div className="container">
          <div className="map-header">
            <h2>Empower Afghan Future: Building Capacity for Progress (EAF)</h2>
            <p>NORA operates across all 34 provinces of Afghanistan through experienced and dedicated teams</p>
          </div>
          
          <div className="clean-map-container">
            <img 
              src={afgMap} 
              alt="Afghanistan Map - NORA Health Services Coverage" 
              className="clean-afghanistan-map"
            />
          </div>
        </div>
      </section>



      {/* Content Section */}
      <section className="scope-work-section">
        <div className="container">
          <div className="scope-cards-grid">
            <div className="scope-card">
              <div className="scope-card-header">
                <i className="fas fa-project-diagram"></i>
                <h3><strong>Project Overview</strong></h3>
              </div>
              <p className="scope-card-description">
                Noor Organization for Rehabilitation of Afghanistan (NORA) has been awarded a sub-grant to implement the "Empower Afghan Future: Building Capacity for Progress (EAF)" project in Baghlan Province, Afghanistan.
                <br/><br/>
                
                
                
                <strong>What Will We Do?</strong>
                <br/><br/>
                This project focuses on institutional capacity building for women-focused local NGOs. Key activities include:
                <br/><br/>
                <strong>• Staff Capacity Development</strong> - Training and workshops for organization staff
                <br/><br/>
                <strong>• System Development</strong> - Creating effective HR, financial, and procurement policies
                <br/><br/>
                <strong>• Strategic Planning</strong> - Developing a strategic plan for the organization
                <br/><br/>
                <strong>• Operational Support</strong> - Financial assistance for administrative costs including:
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;✓ Staff salaries
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;✓ Office rent
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;✓ Utilities (electricity, water)
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;✓ Transportation
                <br/>
                &nbsp;&nbsp;&nbsp;&nbsp;✓ Office supplies and equipment
                <br/><br/>
                
                <strong>Project Objectives</strong>
                <br/><br/>
                <strong>1.</strong> Strengthen institutional capacity of local women-focused NGOs
                <br/><br/>
                <strong>2.</strong> Support organizational sustainability
                <br/><br/>
                <strong>3.</strong> Build effective internal systems (HR, finance, procurement, programs)
                <br/><br/>
                <strong>4.</strong> Enhance staff skills through training programs
                <br/><br/>
                
                <strong>Sustainable Development Goals</strong>
                <br/><br/>
                This project aligns with SDG 16: Peace, Justice and Strong Institutions - strengthening national institutions through capacity building at all levels via international cooperation.
                <br/><br/><br/>
                
                
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default OnGoingProject;